<template>
    <ValidationObserver v-slot="{ handleSubmit }">
        <form class="text-white px-6 py-4 bg-brand" @submit.prevent="handleSubmit(presubmit)">
            <h4 class="text-xl lg:text-3xl font-bold text-center tracking-tight mt-0">Canadian Business Funding</h4>
            <h5 class="text-lg lg:text-xl font-semibold text-center mb-0 tracking-tight">
                The Best For Your Small Business
            </h5>
            <h5 class="lg:text-lg flex justify-center font-bold text-center tracking-tight">
                Get Pre Approved In Minutes!
            </h5>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
                <ValidationProvider
                    v-for="model in models"
                    :key="model.model"
                    tag="div"
                    :name="model.label"
                    :rules="model.rules"
                    class="flex flex-col"
                    v-slot="{ errors }"
                >
                    <label :for="model.model" class="text-white block text-xs mb-1">{{ model.label }}</label>
                    <select
                        class="rounded h-12 text-black"
                        v-if="model.type == 'select'"
                        v-model="form_data[model.model]"
                        :id="model.model"
                    >
                        <option disabled v-text="model.placeholder"></option>
                        <option v-for="option in model.options" :value="option.value" v-text="option.name"></option>
                    </select>
                    <input
                        class="rounded h-12 text-black"
                        :class="{ 'border-red-500': errors[0] }"
                        v-else
                        :type="model.type"
                        v-model="form_data[model.model]"
                    />
                    <span class="text-xs text-gray-100 mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <small class="text-xs block mt-2"
                >By submitting this form, you (i) consent to receiving telemarketing calls, emails and messages from
                SharpShooter Funding and those acting on its behalf at the email address &amp; telephone number you have
                provided above (including your cellular phone number); agree that this consent applies even if the
                number you have provided is currently on any state, federal, or corporate Do-Not-Call registry; and
                understand that you are not required to provide this consent as a condition of receiving any credit or
                services from SharpShooter Funding and that you may apply for business credit by contacting us directly;
                and (ii) acknowledge that you have read SharpShooter Funding
                <a class="underline" href="/application-agreement" target="_blank">Application Agreement</a>, and
                <a class="underline" href="/privacy-policy/" target="_blank">Privacy Policy</a>
                and understand that you may opt out of receiving communications of your choice from SharpShooter Funding
                as provided in the Privacy Policy.</small
            >
            <!-- <div v-if="serverErrors" class="my-4 border-2 border-red-500 p-4 bg-red-500 bg-opacity-10">
                <p class="text-sm">An error has occurred. Please check all fields for errors.</p>
            </div> -->
            <button
                class="w-full bg-white text-black font-semibold bg-opacity-100 mt-4 py-3 text-sm hover:bg-opacity-90 transition duration-200"
                type="submit"
            >
                Submit Form
            </button>
            <div class="mt-12" v-if="hasCLAProp">
                <img class="lazy" src="/app/uploads/2020/04/CLA-Badge-White.png" alt="" />
            </div>
        </form>
        <transition leave-active-class="duration-200">
            <div
                v-show="showModal"
                class="fixed inset-0 overflow-y-auto"
                style="z-index: 9999;"
                aria-labelledby="modal-title"
                role="dialog"
                aria-modal="true"
            >
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <transition
                        enter-active-class="duration-300 ease-out"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="duration-200 ease-in"
                        leave-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div
                            v-show="showModal"
                            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                            aria-hidden="true"
                        ></div>
                    </transition>
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <transition
                        enter-active-class="duration-300 ease-out"
                        enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
                        enter-to-class="translate-y-0 opacity-100 sm:scale-100"
                        leave-active-class="duration-200 ease-in"
                        leave-class="translate-y-0 opacity-100 sm:scale-100"
                        leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            v-show="showModal"
                            class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
                        >
                            <div>
                                <div
                                    class="mx-auto flex items-center text-white justify-center h-12 w-12 rounded-full bg-yellow-200"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="mt-3 text-center sm:mt-5">
                                    <p class="text-base">
                                        Your Small Business must be active for 100+ days & currently generate and be
                                        avle to show an average of $4,166 in monthly sales, deposits & overall revenue.
                                    </p>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-6">
                                <button
                                    @click="showModal = false"
                                    type="button"
                                    class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-400 text-base font-medium text-white hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 sm:text-sm"
                                >
                                    Ok
                                </button>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </transition>
    </ValidationObserver>
</template>

<script>
import models from './application-form.data';
import apiClient from '../../client/api';
import { FORM } from '../../constants/form';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
export default {
    props: ['cla'],
    data() {
        return {
            models,
            showModal: false,
            form_data: {
                utm_source: null,
                utm_campaign: null,
                utm_medium: null,
                affiliate_subid: null,
                affiliate_subid_2: null,
                affiliate_subid_3: null,
                affiliate_subid_4: null,
                partner_id: this.partnerid,
                loan_amount: '',
                loan_intent: '',
                business_legal_name: '',
                date_established: '',
                first_name: '',
                last_name: '',
                email: '',
                cell_phone: '',
                state: 'Select Province',
                // total_monthly_sales: 'Select Average Monthly Sales (volume)',
                credit_score: 'Select Credit Score',
                average_monthly_sales: 'Select Average Monthly Sales'
            }
        };
    },
    props: {
        partnerid: {
            default: null
        }
    },
    created() {
        const params = [
            'utm_source',
            'utm_campaign',
            'utm_medium',
            'affiliate_subid',
            'affiliate_subid_2',
            'affiliate_subid_3',
            'affiliate_subid_4',
            'partner_id'
        ];
        params.forEach(param => {
            if (Cookies.get(param)) this.form_data[param] = Cookies.get(param);
        });
    },
    methods: {
        presubmit() {
            const daysago = dayjs(new Date().setDate(new Date().getDate() - 100)).format('YYYY-MM-DD'); // 100 days ago
            if (
                this.form_data.date_established < daysago &&
                this.form_data.total_monthly_sales != 'Startup Financing - FICO 690+' &&
                    this.form_data.total_monthly_sales != '$4,166 - $10,000'
            ) {
                this.submit();
            } else {
                this.showModal = true;
            }
        },
        submit() {
            const { form_data } = this;
            apiClient
                .post('/lead/create', {
                    utm_source: form_data.utm_source,
                    utm_campaign: form_data.utm_campaign,
                    utm_medium: form_data.utm_medium,
                    affiliate_subid: form_data.affiliate_subid,
                    affiliate_subid_2: form_data.affiliate_subid_2,
                    affiliate_subid_3: form_data.affiliate_subid_3,
                    affiliate_subid_4: form_data.affiliate_subid_4,
                    partner_id: form_data.partner_id,
                    country: process.env.MIX_LEAD_COUNTRY,
                    status: FORM.STATUS.PARTIAL,
                    lead_source_sub: FORM.LEAD_SOURCE_SUB.SHORT,
                    lead_source_medium: FORM.LEAD_SOURCE_MEDIUM.WEB,
                    source: process.env.MIX_APP_URL,
                    webpage_source: window.location.href,
                    business_legal_name: form_data.business_legal_name,
                    loan_amount: form_data.loan_amount,
                    loan_intent: form_data.loan_intent,
                    business_legal_name: form_data.business_legal_name,
                    date_established: form_data.date_established,
                    first_name: form_data.first_name,
                    last_name: form_data.last_name,
                    email: form_data.email,
                    cell_phone: form_data.cell_phone,
                    state: form_data.state,
                    total_monthly_sales: form_data.total_monthly_sales,
                    accepted_terms: 1, // default to true on shortform
                    esign_consent: 1, // default to true on shortform
                    credit_score: form_data.credit_score,
                    average_monthly_sales: form_data.average_monthly_sales
                })
                .then(res => {
                    window.location.href = `${window.location.hostname}/thank-you-page`;
                })
                .catch(err => {
                    console.log(err.response);
                });
        }
    },
    computed: {
        hasCLAProp() {
            return this.cla;
        }
    }
};
</script>
